import "./index.css";
import { clsx } from "clsx";
import { useCallback, useState } from "react";
import { NavLink, useLocation } from "react-router";
import { Popover } from "@/ui-kit";
import type { INavLink } from "../../../AppLayout/AppHeader/Nav/index";

type IProps = {
  item: INavLink;
};

export const HeaderLink = ({ item }: IProps) => {
  const { pathname } = useLocation();
  const isActive = pathname.includes(item.url);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onDismissPopover = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (item.children?.length) {
    const isAnyChildActive = item.children.some((child) =>
      pathname.includes(child.url),
    );

    return (
      <Popover
        open={isOpen}
        onOpenChange={setIsOpen}
        content={
          <div className="nuco-header__nav-popover">
            {item.children.map((child) => {
              const isActive = pathname.includes(child.url);
              return (
                <div
                  key={child.text}
                  className="nuco-header__nav-popover-option-wrapper"
                >
                  <NavLink
                    to={child.url}
                    className={clsx(
                      "nuco-header__nav-popover-item",
                      isActive && "nuco-header__nav-popover-item--active",
                    )}
                    onClick={onDismissPopover}
                  >
                    {child.text}
                  </NavLink>
                </div>
              );
            })}
          </div>
        }
        contentClassName="nuco-header__nav-popover--popover"
        placement="bottom-start"
      >
        <span
          className={clsx(
            "nuco-header__nav-item",
            isAnyChildActive && "nuco-header__nav-item--active",
          )}
        >
          {item.text}
        </span>
      </Popover>
    );
  }

  return (
    <NavLink
      to={item.url}
      className={clsx(
        "nuco-header__nav-item",
        isActive && "nuco-header__nav-item--active",
      )}
      onClick={onDismissPopover}
    >
      {item.text}
    </NavLink>
  );
};
